<div class="bulletin">
  <span class="kcaption-medium">POSTED: {{ bulletin.datePosted }} BY {{ bulletin.author }}</span>
  <span class="ktitle-small">{{ bulletin.title }}</span>
  <span class="kbody-large content">{{ bulletin.content }}</span>
  <app-button class="post-btn" [text]="'Read Full Post'" [class]="'grey'" [icon]="{materialIcon: 'arrow_forward'}"></app-button>
</div>